import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Guitar, Instagram } from 'lucide-react';

export function PublicHeader() {
  const navItems = [
    { to: '/', label: 'Início' },
    { to: '/bandas', label: 'Bandas' },
    { to: '/calendario', label: 'Calendário' },
    { to: '/resultados', label: 'Resultados' },
    { to: '/ranking-eliminatorias', label: 'Ranking' },
    { to: '/regulamento', label: 'Regulamento' },
  ];
  return (
    <header className="sticky top-0 z-40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 border-b border-border">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="public-header-logo">
          <div className="w-9 h-9 rounded-lg bg-[var(--g66-amber)] flex items-center justify-center text-black">
            <Guitar className="w-5 h-5" strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display text-xl text-white">GARAGE 66</div>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Battle Vote</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/'}
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm transition-colors ${
                  isActive ? 'text-[var(--g66-amber)]' : 'text-muted-foreground hover:text-white'
                }`
              }
              data-testid={`nav-${n.to.replace('/', '') || 'home'}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}

export function PublicFooter({ settings }) {
  return (
    <footer className="border-t border-border mt-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-10 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <div className="font-display text-2xl text-white">{settings?.pub_name || 'Pub Garage 66'}</div>
          <p className="text-sm text-muted-foreground mt-2">
            {settings?.address || 'Toda quinta-feira, duas bandas no palco. O público decide.'}
          </p>
        </div>
        <div>
          <div className="text-sm font-semibold text-white uppercase tracking-widest mb-2">Navegção</div>
          <ul className="space-y-1 text-sm text-muted-foreground">
            <li><Link to="/bandas" className="hover:text-white">Bandas participantes</Link></li>
            <li><Link to="/calendario" className="hover:text-white">Calendário de disputas</Link></li>
            <li><Link to="/resultados" className="hover:text-white">Resultados</Link></li>
            <li><Link to="/regulamento" className="hover:text-white">Regulamento</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-white uppercase tracking-widest mb-2">Contato</div>
          {settings?.instagram_url && (
            <a href={settings.instagram_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-white">
              <Instagram className="w-4 h-4" /> Instagram
            </a>
          )}
          <p className="text-xs text-muted-foreground mt-4">
            © {new Date().getFullYear()} {settings?.pub_name || 'Pub Garage 66'} — Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
